<template>
	<div>
		<AppContent is-empty-header>
			<HomeContainer />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppContent from '@/components/common/AppContent.vue';
import AppFooter from '@/components/common/AppFooter.vue';
import HomeContainer from '@/components/Home/HomeContainer';

export default {
	components: {
		AppContent,
		AppFooter,
		HomeContainer,
	},
};
</script>
